'use client';

import { useEffect } from 'react';

interface IAsyncStylesheetLinksProps {
    hrefs: string[];
}

/**
 * Appends stylesheets after hydration so they do not block the first paint.
 * Same pattern as AsyncIconFontLinks (avoids SSR media="print" hydration mismatch).
 */
export function AsyncStylesheetLinks({ hrefs }: IAsyncStylesheetLinksProps): null {
    useEffect(() => {
        const appended: HTMLLinkElement[] = [];

        for (const href of hrefs) {
            if (document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
                continue;
            }

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            document.head.appendChild(link);
            appended.push(link);
        }

        return () => {
            for (const link of appended) {
                link.remove();
            }
        };
    }, [hrefs]);

    return null;
}
